import React, { Component } from 'react';
import { Typography, Button, IconButton, LinearProgress } from '@material-ui/core';
import { KeyboardBackspaceOutlined } from '@material-ui/icons';
import '../../styles/Carousel.scss';
import '../../styles/Globales.scss';
import appStore from '../../stores/AppStore';
import ViewConstants from '../../utils/ViewConstants';
import OfertaConsumoComponent from './OfertaConsumoComponent';
import OfertaTarjetaComponent from './OfertaTarjetaComponent';
import OfertaCuentaVistaComponent from './OfertaCuentaVistaComponent';

export default class OfertaComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oferta: {},
      creditoOpcional: true,
    };
  }

  componentDidMount = () => {
    const oferta = appStore.ofertasStore.oferta;
    let creditoOpcionalTarjeta = true;
    let creditoOpcionalCuenta = true;
    if (oferta.ofertaTarjeta) {
      creditoOpcionalTarjeta = oferta.ofertaTarjeta.deuda === 0;
    }
    if (oferta.ofertaCuenta) {
      const cuentasConDeuda = oferta.ofertaCuenta.productosReemplaza.filter((item) => {
        return item.deudaLinea > 0;
      });
      if (cuentasConDeuda) {
        creditoOpcionalCuenta = cuentasConDeuda.length === 0;
      }
    }
    this.setState({ oferta: appStore.ofertasStore.oferta, creditoOpcional: creditoOpcionalCuenta && creditoOpcionalTarjeta });
  };

  onChangeSeleccionado = (evt) => {
    this.setState({ seleccionado: evt.target.checked });
  };

  onAvanzar = () => {
    appStore.ofertasStore.guardarOfertaAceptada(this.tipoOfertaAceptada(), this.onOfertaGuardada);
  };

  tipoOfertaAceptada = () => {
    let tiposOferta = this.state.oferta.tipoOferta.split('+');
    const ofertaTarjeta = this.state.oferta.ofertaTarjeta;
    const ofertaCredito = this.state.oferta.ofertaCredito;
    const ofertaCuenta = this.state.oferta.ofertaCuenta;

    if (ofertaTarjeta) {
      if (!ofertaTarjeta.selected) {
        tiposOferta = this.removeItem(tiposOferta, 'TARCRE');
      }
    }
    if (ofertaCredito) {
      if (!ofertaCredito.selected) {
        tiposOferta = this.removeItem(tiposOferta, 'CRECON');
        tiposOferta = this.removeItem(tiposOferta, 'LINCRE');
      }
    }
    if (ofertaCuenta) {
      if (!ofertaCuenta.selected) {
        tiposOferta = this.removeItem(tiposOferta, 'CTAVIS');
      }
    }
    return tiposOferta.join('+');
  };

  removeItem = (arr, value) => {
    const index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  };

  onOfertaGuardada = () => {
    appStore.ofertasStore.oferta = this.state.oferta;
    appStore.changeNavigation(ViewConstants.ETAPA_OFERTA_ACEPTADA);
  };

  onVerMisSolicitudes = () => {
    appStore.clearStores();
    appStore.cargarSolicitudesCliente(this.onSolicitudesCargadas, 0);
  };

  onSolicitudesCargadas = () => {
    appStore.changeNavigation(ViewConstants.ETAPA_LISTADO_SOLICITUDES);
  };

  onVolver = () => {
    appStore.changeNavigation(ViewConstants.ETAPA_CONFIRMACION_PRDUCTOS);
  };

  renderCredito = (producto) => {
    let result;
    if (producto) {
      producto = this.state.oferta.ofertaCredito;
      result = <OfertaConsumoComponent producto={producto} onSelectionChange={this.onChangeCredito} eliminable={this.state.creditoOpcional} />;
    }
    return result;
  };

  onChangeCredito = (value) => {
    this.setState((prevState) => ({
        oferta: {
          ...prevState.oferta,
          ofertaCredito: {
            selected: value,
          },
        },
    }));
  };

  renderTarjeta = (producto) => {
    let result;
    if (producto) {
      producto = this.state.oferta.ofertaTarjeta;
      result = <OfertaTarjetaComponent producto={producto} onSelectionChange={this.onChangeTarjeta} />;
    }
    return result;
  };

  onChangeTarjeta = (value) => {
    this.setState((prevState) => ({
      oferta: {
        ...prevState.oferta,
        ofertaTarjeta: {
          selected: value,
        },
        ofertaCredito: {
          selected: (prevState.ofertaCredito && prevState.ofertaTarjeta.deuda > 0) ? value : prevState?.ofertaCredito?.selected,
        }
      }
    }));
  };

  renderCuenta = (producto) => {
    let result;
    if (producto) {
      producto = this.state.oferta.ofertaCuenta;
      result = <OfertaCuentaVistaComponent producto={producto} onSelectionChange={this.onChangeCuenta} />;
    }
    return result;
  };

  onChangeCuenta = (value) => {
    this.setState((prevState) => ({
      oferta: {
        ...prevState.oferta,
        ofertaCuenta: {
          selected: value
        }
      }
    }));
  };

  generarPdf = () => {
    appStore.ofertasStore.generarPdf(this.state.oferta.tipoOferta, this.onPdfGenerado);
  };

  onPdfGenerado = (pdf) => {
    const pdfName = 'data:application/pdf;base64,' + pdf;
    const link = document.createElement('a');
    link.href = pdfName;
    link.setAttribute('download', 'oferta_portabilidad.pdf');
    link.click();
  };

  hayProductosSeleccionados = (oferta) => {
    let tarjeta;
    let credito;
    let cuenta;
    tarjeta = oferta.ofertaTarjeta && oferta.ofertaTarjeta.selected;
    credito = oferta.ofertaCredito && oferta.ofertaCredito.selected;
    cuenta = oferta.ofertaCuenta && oferta.ofertaCuenta.selected;
    return tarjeta || credito || cuenta;
  };
  render() {
    let classItem = 'paginaCarousel';
    if (this.state.seleccionado) {
      classItem = 'paginaCarouselSeleccionado';
    }
    const solicitarDisabled = !this.hayProductosSeleccionados(this.state.oferta);
    return (
      <div className="contenedorPrincipal">
        <div className="paso">
          <Typography className="tituloBR">
            {' '}
            <IconButton onClick={this.onVolver}>
              <KeyboardBackspaceOutlined />
            </IconButton>
            Felicidades tenemos los siguientes productos para ti!
          </Typography>
          <Typography className="bajadaTitulo ">Escoge los productos que deseas contratar:</Typography>
        </div>
        <LinearProgress variant="determinate" color="secondary" value={5 * (100 / 6)} className="barraProgreso" />

        <div className="contnedorPagina">
          <div className="etiquetaOferta">
            <Typography>{this.props.titulo}</Typography>
          </div>
          <div className={classItem}>
            {this.renderCredito(this.state.oferta.ofertaCredito)}
            {this.renderTarjeta(this.state.oferta.ofertaTarjeta)}
            {this.renderCuenta(this.state.oferta.ofertaCuenta)}
          </div>
        </div>
        <div className="buttonCarousel">
          <Button color="primary" id="btnVerifica" className="btnRipley" onClick={this.onAvanzar} disabled={solicitarDisabled}>
            Solicitar
          </Button>
        </div>
      </div>
    );
  }
}
